import {
	subDays,
	addDays,
	startOfDay,
	format,
	endOfDay,
	endOfWeek,
	intervalToDuration,
	differenceInDays
} from 'date-fns';
import ruLocale from 'date-fns/locale/ru';

const dateHash = {
	yesterday: {
		title: 'Вчера',
		values: () => ({
			startDate: format(startOfDay(subDays(new Date(), 1)), 'yyyy-MM-dd'),
			endDate: format(endOfDay(subDays(new Date(), 1)), 'yyyy-MM-dd')
		})
	},
	today: {
		title: 'Сегодня',
		values: () => ({
			startDate: format(startOfDay(new Date()), 'yyyy-MM-dd'),
			endDate: format(endOfDay(new Date()), 'yyyy-MM-dd')
		})
	},
	tomorrow: {
		title: 'Завтра',
		values: () => ({
			startDate: format(startOfDay(addDays(new Date(), 1)), 'yyyy-MM-dd'),
			endDate: format(endOfDay(addDays(new Date(), 1)), 'yyyy-MM-dd')
		})
	},
	weekends: {
		title: 'Выходные',
		values: () => ({
			startDate: format(
				startOfDay(subDays(endOfWeek(new Date(), { locale: ruLocale }), 1)),
				'yyyy-MM-dd'
			),
			endDate: format(
				endOfDay(endOfWeek(new Date(), { locale: ruLocale })),
				'yyyy-MM-dd'
			)
		})
	}
};

export const formatDuration = (startDate, endDate, options = {}) => {
	const extendedOptions = {
		formatList: ['д', 'ч', 'м'],
		withZeros: false,
		...options
	};
	const interval = intervalToDuration({ start: startDate, end: endDate });

	return [
		differenceInDays(startDate, endDate),
		interval.hours,
		interval.minutes
	]
		.reduce((memo, num, index) => {
			if (num || extendedOptions.withZeros) {
				memo.push(`${num} ${extendedOptions.formatList[index]}`);
			}

			return memo;
		}, [])
		.join(' : ');
};

export default {
	dateHash
};
